import React, { useEffect, useState } from 'react';
import '../styles/RoyalIndicator.css';

const RoyalIndicator = ({ position, color, inCheck, embodiment, restricted = false }) => {
  const [pulse, setPulse] = useState(false);
  const file = position % 8;
  const rank = Math.floor(position / 8);
  
  useEffect(() => {
    if (inCheck) {
      setPulse(true);
      const interval = setInterval(() => {
        setPulse(p => !p);
      }, 600);
      return () => clearInterval(interval);
    } else {
      setPulse(false);
    }
  }, [inCheck]);

  const showNotch = typeof embodiment === 'string' && embodiment.startsWith('fight_to_be_king');

  return (
    <div
      className={`royal-indicator ${color} ${inCheck ? 'in-check' : ''} ${pulse ? 'pulse' : ''} ${restricted ? 'restricted' : ''}`}
      style={{
        gridColumn: file + 1,
        gridRow: 8 - rank,
        pointerEvents: 'none'
      }}
      data-testid={`royal-indicator-${color}${restricted ? '-restricted' : ''}${inCheck ? '-check' : ''}`}
    >
      {/* Outer orange ring for restricted Dukes (Pro mode after king capture) */}
      {restricted && <div className="ring restricted-ring" data-testid={`duke-restricted-ring-${color}`} />}
      <div className="ring" />
      {showNotch && <div className="notch" />}
    </div>
  );
};

export default RoyalIndicator;
